module.exports = __webpack_public_path__ + "static/media/pdf.698d264b.svg";